import React from 'react';
import { useTranslation } from 'react-i18next';
import './TargetingCancelDialog.css';
import getWeaponTargetingMessage from '../targeting/getWeaponTargetingMessage';

const TargetingCancelDialog = ({
  deployMode,
  strategemMode,
  weaponMode,
  weaponDeployMode,
  weaponDeployTargetInfo,
  droneMode,
  strategemTargetInfo,
  selectedDeployOrderId,
  deployTargetInfo,
  onCancelDeploy,
  onCancelStrategem,
  onCancelWeapon,
  onCancelWeaponDeploy,
  onCancelDrone
}) => {
  const { t } = useTranslation();
  
  // Don't render if no mode is active
  if (!deployMode && !strategemMode && !weaponMode && !weaponDeployMode && !droneMode) {
    return null;
  }

  // Unit 349 (Enhanced Scorpion) requires mandatory targeting - cannot cancel
  const isMandatoryTargeting = selectedDeployOrderId === 349;

  return (
    <div className="targeting-cancel-dialog">
      {deployMode && (
        <div className="targeting-message">
          Select a target for {deployTargetInfo?.order?.name || 'unit'}
          {!isMandatoryTargeting && (
            <button 
              onClick={onCancelDeploy}
              className="cancel-button"
            >
              {t('battleUI.cancelTargeting')}
            </button>
          )}
          {isMandatoryTargeting && (
            <span className="mandatory-targeting-note" style={{ marginLeft: '10px', color: '#ff6b6b', fontSize: '0.9em' }}>
              (Targeting is mandatory - must select a unit)
            </span>
          )}
        </div>
      )}
      
      {strategemMode && (
        <div className="targeting-message">
          🎯 Strategem Targeting Mode: Select a target
          <button 
            onClick={onCancelStrategem}
            className="cancel-button"
          >
            {t('battleUI.cancelTargeting')}
          </button>
        </div>
      )}

      {weaponMode && (
        <div className="targeting-message">
          🛠️ Weapon Targeting Mode: Select a target unit to attach
          <button 
            onClick={onCancelWeapon}
            className="cancel-button"
          >
            {t('battleUI.cancelTargeting')}
          </button>
        </div>
      )}

      {weaponDeployMode && (
        <div className="targeting-message">
          🎯 {getWeaponTargetingMessage(weaponDeployTargetInfo?.weaponId)}
          <button 
            onClick={onCancelWeaponDeploy}
            className="cancel-button"
          >
            {t('battleUI.cancelTargeting')}
          </button>
        </div>
      )}

      {droneMode && (
        <div className="targeting-message">
          🚁 Drone Targeting Mode: Select a target unit for drone effect
          <button 
            onClick={onCancelDrone}
            className="cancel-button"
          >
            {t('battleUI.cancelTargeting')}
          </button>
        </div>
      )}
    </div>
  );
};

export default TargetingCancelDialog;
